import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import success from '@/assets/images/svg/check-icon.svg';
import error from '@/assets/images/svg/error.svg';
import { BaseDialog } from '@/components/shared/base-dialog';
import { useBootstrapData } from '@/data/user/bootstrap-data';
import { Features } from '@/models/bootstrap/plan';
import { useCheckoutWizard } from '@/packages/courses/pages/checkout/hooks/useCheckoutWizard';
import { CheckoutStepIds } from '@/packages/courses/pages/checkout/types';

const SUPPORT_URL =
  'https://api.whatsapp.com/send/?phone=5511987566079&text&type=phone_number&app_absent=0';

interface ActionsProps {
  primaryAction: {
    label: string;
    onClick: () => void;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
}

const Actions = ({ primaryAction, secondaryAction }: ActionsProps) => {
  return (
    <Stack direction="row" spacing={2} justifyContent="end">
      {secondaryAction && (
        <Button onClick={secondaryAction.onClick}>
          {secondaryAction.label}
        </Button>
      )}
      <Button onClick={primaryAction.onClick} variant="contained">
        {primaryAction.label}
      </Button>
    </Stack>
  );
};

interface StatusDialogProps {
  status: 'success' | 'failed';
  onClose: () => void;
}

export const StatusDialog = ({ status, onClose }: StatusDialogProps) => {
  const navigate = useNavigate();
  const { actions } = useCheckoutWizard();
  const { bootstrap } = useBootstrapData();
  const hasRefund = bootstrap?.plan?.features?.some(
    (feature) => feature.name === Features.Subsidies
  );

  const content = {
    success: {
      img: success,
      title: 'Pagamento confirmado!',
      description:
        'Entraremos em contato com os próximos passos pelo WhatsApp, fique de olho!',
      primaryAction: {
        label: 'Fechar',
        onClick: () => navigate('/'),
      },
      ...(hasRefund && {
        secondaryAction: {
          label: 'Solicitar reembolso',
          onClick: () => navigate('/meus-reembolsos'),
        },
      }),
    },
    failed: {
      img: error,
      title: 'Pagamento não identificado!',
      description:
        'Infelizmente, não identificamos o seu pagamento. Confira se houve algum problema com o aplicativo do banco, ou altere a forma da pagamento. ',
      primaryAction: {
        label: 'Alterar forma de pagamento',
        onClick: () => {
          actions.navigate(CheckoutStepIds.PaymentMethod);
          onClose();
        },
      },
      secondaryAction: {
        label: 'Falar com atendimento',
        onClick: () => window.open(SUPPORT_URL),
      },
    },
  };

  return (
    <BaseDialog
      open
      onClose={onClose}
      fullWidth
      actionsComponent={
        <Actions
          primaryAction={content[status].primaryAction}
          secondaryAction={content[status].secondaryAction}
        />
      }
      icon={<img src={content[status].img} width={56} height={56} />}
      title={content[status].title}
    >
      <Typography>{content[status].description}</Typography>
    </BaseDialog>
  );
};
